import { Link } from "react-router-dom";
import { useDocumentTitle } from "@/components/useDocumentTitle";
import { Card, EmptyState } from "@/ui";

export function NotFoundPage() {
  useDocumentTitle("Not found");
  return (
    <div className="page">
      <Card>
        <EmptyState
          title="Page not found"
          description="That address does not exist in the panel."
          action={
            <Link className="link" to="/">
              Go to Health
            </Link>
          }
        />
      </Card>
    </div>
  );
}
